import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TeamlidProfiel } from '../../model/teamlid.model';
import { DeelDetailsListComponent } from '../deel-details-list/deel-details-list.component';
import { ParkourButtonComponent } from '@parkour/ui';

@Component({
  selector: 'parkour-teamlid-details-edit-bottom-section',
  standalone: true,
  imports: [DeelDetailsListComponent, ParkourButtonComponent],
  templateUrl: './teamlid-details-edit-bottom-section.component.html',
})
export class TeamlidDetailsEditBottomSectionComponent {
  @Input({ required: true }) teamlid!: TeamlidProfiel;
  @Output() verwijderClick = new EventEmitter<void>();
  @Output() activeerClick = new EventEmitter<void>();
  @Output() blokkeerClick = new EventEmitter<void>();
}
